import {Stats} from './stats';

export class StarStatLevel {
	starLevel:number=0;
	maxLevel:number=0;
	stats:Stats = new Stats();
}